export enum FEATURE_FLAGS {
    SpellingGrammarMetrics = "spelling_grammar_metrics",
    GrammarMetric = "grammar_metric",
    WritingIssuesFilter = "writing_issues_filter",
    ScorecardsAgentsLogin = "scorecards_agents_login",
    NewMetricDistributionSelector = "new_metric_distribution_selector",
    InternalFeatureFlagToggler = "internal_feature_flag_toggler",
    CustomerOverview = "customer_overview",
    NewInteractionCountPercentageMetric = "new_interaction_count_percentage_metric",
    InteractionAgentPerformanceSummary = "interaction_agent_performance_summary",
    InteractionTableReviewStatusMetric = "interaction_table_review_status_metric",
    FrequentCustomersScreen = "frequent_customers_screen",
    HideMetricOverTimeCharts = "hide_metric_over_time_charts",
    EditCompletedReviews = "edit_completed_reviews",
    Watchtower2_0 = "watchtower_2.0",
    Clickhouse = "clickhouse",
    HomeScreenPhaseTwo = "home_screen_phase_2",
    ReviewsWithoutInteraction = "reviews_without_interaction",
    Watchtower2_0ThemeToggler = "watchtower_2.0_theme_toggler",
    EditAIScorecards = "edit_ai_scorecards",
    TagPastInteractions = "tag_past_interactions",
    ExploreChartsHideSplitByCategories = "explore_charts_hide_split_by_categories",
    AgentActivityNewMetrics = "agent_activity_new_metrics",
    AgentActivityMetricManipulation = "agent_activity_metric_manipulation",
    EdgetierChristmas = "edgetier-christmas",
    InteractionCallsPlayFromMessage = "interaction_calls_play_from_message",
    ViewAIContactReasonTags = "view_ai_contact_reason_tags",
    BackgroundInteractionsExport = "background_interactions_export",
    AgentTagIdInReviewsFilters = "agent_tag_id_in_reviews_filters",
    EditContactReasons = "edit_contact_reasons",
    WatchtowerAiAssistant = "watchtower_ai_assistant",
    SpotlightExpansionM1 = "spotlight_expansion_m1",
    SpotlightExpansionM2 = "spotlight_expansion_m2",
    AgentActivityQuestionReportingM3 = "agent_activity_question_reporting_m3",
    AgentSpotlight = "agent_spotlight",
    AiChatSessionReplay = "ai_chat_session_replay",
    AiAssistantSessionManagement = "ai_assistant_session_management",
    AlternativeUserEmail = "alternative_user_email",
    CoachReviewRevisionProcessM1 = "coach_review_revision_process_m1",
    CoachReviewRevisionProcessM2 = "coach_review_revision_process_m2",
    CoachReviewStatuses = "coach_review_statuses",
    ExportReviewsTable = "export_reviews_table",
    Sonar2_0 = "sonar_2.0",
    CustomerSuccessSupportWidget = "customer_success_support_widget",
}

export interface IEdgeIdentity {
    identity_uuid: string;
    identifier: string;
    dashboard_alias: string;
}

export interface IEdgeIdentityFeatureState {
    feature: {
        id: number;
        name: string;
        type: string;
    };
    enabled: boolean;
    feature_state_value: string | null;
    overridden_by: "IDENTITY" | "SEGMENT" | null;
    segment: { id: number; name: string } | null;
    multivariate_feature_state_values: Array<string>;
}
